module.exports = __webpack_public_path__ + "img/app.b9590170.png";